export default function progressBar() {
    const bar = document.querySelector('.gh-progress');
    if (!bar) return;

    const isPost = document.body.classList.contains('post-template') ||
                   document.body.classList.contains('page-template');
    if (!isPost) return;

    let ticking = false;

    function updateProgress() {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        bar.style.width = progress + '%';
        ticking = false;
    }

    window.addEventListener('scroll', function() {
        if (!ticking) {
            requestAnimationFrame(updateProgress);
            ticking = true;
        }
    }, { passive: true });
}
